<template>
  <section id="about">
    <div class="main">
      <div class="personal-infos">
        <h1 class="nome">
          {{ `${users.firstName} ${users.lastName}` }}
        </h1>

        <p class="profissao">
          {{ resume.title }}
        </p>

        <div class="location">
          <img v-if="resume.location" src="@/assets/icons/location.svg" />
          <p>{{ resume.location }}</p>
          <!-- <div class="edit">
            <img src="@/assets/icons/menu/edit.svg" @click="openModal" />
          </div> -->
        </div>

        <div v-if="resume.email" class="email">
          <img src="@/assets/icons/mail.svg" />
          <p>{{ resume.email }}</p>
        </div>

        <div v-if="resume.phone" class="phone">
          <img src="@/assets/icons/phone.svg" />
          <p>{{ resume.phone }}</p>
        </div>

        <!-- <div class="social">
          <a :href="resume.facebook"
            ><img src="@/assets/icons/social-media/facebook.png" height="48"
          /></a>
          <a :href="resume.twitter"
            ><img src="@/assets/icons/social-media/twitter.png" height="48"
          /></a>
          <a :href="resume.linkedin"
            ><img src="@/assets/icons/social-media/linkedin.png" height="48"
          /></a>
        </div> -->
      </div>

      <div class="container__video">
        <iframe
          :src="users.trailer_about"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        />
      </div>
    </div>

    <div class="description">
      <!-- <div class="container__about-title">Sobre</div> -->
      <!-- <div class="edit">
        <img src="@/assets/icons/menu/edit.svg" @click="openModalAbout" />
      </div> -->
      <p>
        {{ resume.about }}
      </p>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';

export default {
  data() {
    return {
      isModalVisible: false,
      users: [],
    };
  },

  computed: {
    ...mapGetters('auth', ['resume']),
  },
  async created() {
    await this.fetchUsers();
    // console.log('aqui', this.users);
  },

  methods: {
    openModal() {
      this.$root.$emit('modal', {
        component: 'teacher/About.vue',
      });
    },

    openModalAbout() {
      this.$root.$emit('modal', {
        component: 'teacher/Description.vue',
      });
    },
    async fetchUsers() {
      const id = localStorage.getItem('user');
      const token = localStorage.getItem('token');
      const { data } = await axios.get(
        `${process.env.VUE_APP_API}/user/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      this.users = data;
    },
  },
};
</script>

<style lang="scss" scoped>
#about {
  background-color: white;
  width: 100%;

  .main {
    display: flex;
    justify-content: space-between;
    padding: 50px;

    .personal-infos {
      .nome {
        font-style: normal;
        font-weight: bold;
        font-size: 60px;
        line-height: 58px;
        display: flex;
        align-items: center;
        letter-spacing: 1px;
        color: #3a3b3f;
      }

      .profissao {
        font-style: normal;
        font-weight: normal;
        font-size: 36px;
        line-height: 58px;
        display: flex;
        align-items: center;
        letter-spacing: 1px;
        color: #66788a;
        margin-bottom: 50px;
      }

      div {
        font-family: 'Roboto', sans-serif;
        color: rgba(102, 120, 138, 1);
        font-size: 28px;
        margin-bottom: 20px;

        img {
          margin-right: 16px;
        }

        div.edit {
          margin-bottom: 0;
          margin-left: 20px;
          cursor: pointer;
        }
      }

      .location {
        display: flex;
        flex-direction: row;
        width: 127%;
      }

      .email {
        display: flex;
        flex-direction: row;
      }

      .phone {
        display: flex;
        flex-direction: row;
      }

      .social {
        display: flex;
        flex-direction: row;
        img {
          margin-right: 25px;
        }
      }
    }

    .container__video {
      flex: 1;
      display: flex;
      justify-content: flex-end;

      iframe {
        width: 100%;
        max-width: 500px;
      }
    }
  }

  .description {
    border-top: 1px solid #e4e7eb;
    padding: 50px 50px;
    padding-top: 0;
    position: relative;

    .container__about-title {
      background: #1226aa;
      color: #fff;
      width: 157px;
      height: 42px;
      font-size: 1.375rem;
      line-height: 26px;
      text-align: center;
      padding: 8px 50px;
      margin-bottom: 30px;
    }
    .edit {
      position: absolute;
      top: 15%;
      right: 5%;
      cursor: pointer;
    }
    p {
      font-style: normal;
      font-weight: normal;
      font-size: 22px;
      line-height: 32px;
      letter-spacing: 1px;
      color: rgba(102, 120, 138, 0.5);
    }
  }
}

@media (max-width: 768px) {
  #about {
    .main {
      padding: 30px;
      flex-direction: column;

      .personal-infos {
        .nome {
          font-size: 36px;
        }
        .profissao {
          font-size: 24px;
        }

        .location,
        .email,
        .phone {
          font-size: 22px;
        }
      }
    }
  }
}
</style>
